export { default } from './Organizers.component';
